module.exports = "<div class=\"tabs\">\n    <div *ngFor=\"let tab of tabs\" [class.active]=\"customerService.tabActive==tab.title\" (click)=\"changeTab(tab)\">{{tab.title}}</div>\n</div>\n<div *ngFor=\"let tab of tabs\">\n    <div *ngIf=\"tab.title==customerService.tabActive\">\n        <my-summary *ngIf=\"tab.component=='summary'\" [privateId]=\"privateId\"></my-summary>\n        <my-table *ngIf=\"tab.component=='table'\" [privateId]=\"privateId\" [functionLoader]=\"tab.functionLoader\"></my-table>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/components/tabs/tabs.component.html
// module id = 741
// module chunks = 1